var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2189 11.3039C10.3033 11.2789 10.8814 10.7195 12.7596 8.84764C14.2158 7.39764 15.2189 6.37264 15.2596 6.29764C15.3471 6.12889 15.3471 5.87264 15.2596 5.70389C15.1596 5.51952 10.4252 0.797642 10.2752 0.735142C9.72207 0.507017 9.15332 1.07889 9.40332 1.61014C9.44395 1.69452 10.0439 2.31327 11.2471 3.51639C12.2283 4.49452 13.0314 5.30702 13.0314 5.31952C13.0314 5.33202 10.3471 5.34764 7.06582 5.35077L1.1002 5.36014L0.962698 5.45389C0.531448 5.75702 0.593948 6.41014 1.06895 6.61014C1.17207 6.65077 1.83457 6.65702 7.10957 6.65702C10.3658 6.65702 13.0314 6.66639 13.0314 6.67889C13.0314 6.69139 12.2096 7.52577 11.2064 8.53202C9.41582 10.3258 9.38145 10.3633 9.3502 10.5164C9.24082 11.0445 9.7002 11.4601 10.2189 11.3039Z",
    fill: "#717274"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.1ab0abaac8f78b88d18fefecfbd98b3f.svg";
export { ForwardRef as ReactComponent };